import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=681b7318&scoped=true&"
import script from "./SalesReport.vue?vue&type=script&lang=js&"
export * from "./SalesReport.vue?vue&type=script&lang=js&"
import style0 from "./SalesReport.vue?vue&type=style&index=0&id=681b7318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b7318",
  null
  
)

export default component.exports